import { useState } from "react";
import TerminalsPageView from "./TerminalsPageView";
import useCustomEffect from "../../../hooks/useCustomEffect";
import useEvaApi, { EvaApiCall } from "../../../hooks/useEvaApi";

function TerminalsPage() {
  const callEvaApi = useEvaApi();
  const [terminalUser, setTerminalUser] = useState(null);
  const [editData, setEditData] = useState({
    editing: false,
    password: "",
    password_confirmation: "",
  });
  const [submitError, setSubmitError] = useState(null);

  /**
   * initialize the page
   */
  useCustomEffect(() => {
    fetchTerminalUserData();
  });

  /**
   * This method will fetch the terminal user from the API
   */
  async function fetchTerminalUserData() {
    await callEvaApi(
      new EvaApiCall("terminals/user")
        .setLoadingGroup("terminals_page_user_fetch")
        .setOnSuccess((response) => {
          setTerminalUser(response.data.data);
        }),
    );
  }

  /**
   * This method will handle the cancel edit event
   */
  function onCancelEdit() {
    setEditData({
      editing: false,
      password: "",
      password_confirmation: "",
    });
  }

  /**
   * This method will handle the confirm edit event
   */
  async function onConfirmEdit() {
    await callEvaApi(
      new EvaApiCall(`terminals/user`)
        .setMethod("PUT")
        .setData({
          password: editData.password,
          password_confirmation: editData.password_confirmation,
        })
        .setLoadingGroup("terminals_page_submit")
        .setAlertSuccess(true)
        .setAlertError(true)
        .setErrorState(setSubmitError)
        .setOnSuccess(() => {
          setEditData({
            editing: false,
            password: "",
            password_confirmation: "",
          });
        }),
    );
  }

  return (
    <TerminalsPageView
      terminalUser={terminalUser}
      editData={editData}
      setEditData={setEditData}
      onCancelEdit={onCancelEdit}
      onConfirmEdit={onConfirmEdit}
      submitError={submitError}
    />
  );
}

export default TerminalsPage;
